import { Component, Prop, Vue } from 'nuxt-property-decorator';

import IconAlert from '../../assets/svg/alert-triangle.svg';

@Component<DateElement>({
  components: {
    IconAlert
  }
})
export default class DateElement extends Vue {
  @Prop({ type: String })
  dayString!: string;

  @Prop({ type: String })
  dayNumber!: string;

  @Prop({ type: String })
  hour!: string;

  get noDate(): boolean {
    return !this.dayString && !this.dayNumber;
  }
}
